"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { toast } from "@/components/ui/sonner";
import { useCartStore } from "@/features/cart/components/cart-provider";
import { usePendingRemovals } from "@/features/cart/components/pending-removals-provider";
import { useRouter } from "@/i18n/navigation";

// Positions waiting out their undo window are gone as far as the customer is
// concerned, so the checkout CTA is validated without them and leaving the cart
// sends their removals right away instead of holding the customer back.
export const useGoToCheckout = () => {
  const t = useTranslations();
  const router = useRouter();
  const cartStore = useCartStore((state) => state);
  const { flush, getRemovalStatus } = usePendingRemovals();
  const [isLeaving, setIsLeaving] = useState(false);

  const activeItems = cartStore.items.filter(
    (item) => getRemovalStatus(item.configurationItem.id) === "idle",
  );

  const goToCheckout = async () => {
    const hasDisabledItems = activeItems.some((item) =>
      cartStore.disabledItems?.includes(item.configurationItem.id),
    );

    if (hasDisabledItems) {
      toast.error(t("cart.pricing.disabledItems"));
      return;
    }

    setIsLeaving(true);
    // Waiting out the writes keeps the checkout and its begin_checkout event
    // from listing a position that is already being removed.
    await flush();
    router.push("/checkout");
  };

  return { activeItems, goToCheckout, isLeaving };
};
